module.exports = __webpack_public_path__ + "media/images/views/dashboard/star-4-e42a8f67f171db567e767b8a5de62cde.svg";